import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresDescuentosAplicarConfirmar', {
    template: template,
    controller: NominasNominaColaboradoresDescuentosAplicarConfirmarComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      data: '<',
      onClose: '&',
    },
  })

function NominasNominaColaboradoresDescuentosAplicarConfirmarComponent($state, NominasNominaColaboradoresDescuentos) {
  let $ctrl = this

  $ctrl.$onChanges = $onChanges
  $ctrl.aceptar = aceptar
  $ctrl.actualizar = actualizar
  $ctrl.cerrar = cerrar
  $ctrl.completado = false
  $ctrl.descuentos = 0
  $ctrl.error = null
  $ctrl.procesando = false
  $ctrl.total = 0

  function $onChanges(changes) {
    if (changes.data) {
      $ctrl.descuentos = 0
      $ctrl.total = 0

      $ctrl.data = $ctrl.data
        .map(function (item) {
          let colaborador = {
            id_proyecto: item.ID_Empresa,
            id_colaborador: item.ID_Empleado,
            descuentos: [],
          }

          angular.forEach(item.Deducciones, function (deduccion, idConcepto) {
            let descuento = {
              id_concepto: idConcepto,
              importe: Math.max(0, angular.isNumber(deduccion.editado) ? deduccion.editado : deduccion.calculado),
              editado: angular.isNumber(deduccion.editado),
            }

            if (descuento.importe === 0)
              return

            $ctrl.total += descuento.importe
            $ctrl.descuentos += 1

            colaborador.descuentos.push(descuento)
          })

          return colaborador
        })
        .filter(function (colaborador) {
          return colaborador.descuentos.length > 0
        })
    }
  }

  function aceptar() {
    if ($ctrl.procesando)
      return

    $ctrl.procesando = true
    $ctrl.completado = false
    $ctrl.error = null

    return NominasNominaColaboradoresDescuentos.post($ctrl.idProyecto, $ctrl.idNomina, $ctrl.data)
      .then(function () {
        $ctrl.completado = true
      })
      .catch(function (response) {
        $ctrl.error = response.data
      })
      .finally(function () {
        $ctrl.procesando = false
      })
  }

  function actualizar() {
    $state.go('nominas.detalladoNomina.colaboradores.descuentos', {
      idEmpresa: $ctrl.idProyecto,
      idNomina: $ctrl.idNomina,
    }, {reload: true})
  }

  function cerrar() {
    $ctrl.onClose()
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/descuentos/aplicar/confirmar/component.js